import Vue from 'vue'
import DataService from '../../services/data'

export const SET_RETURN_SHOP_PORTAL = 'SET_RETURN_SHOP_PORTAL'
export const SET_RETURN_SHOP_PORTAL_ACTIVE = 'SET_RETURN_SHOP_PORTAL_ACTIVE'
export const RENAME_RETURN_SHOP_PORTAL = 'RENAME_RETURN_SHOP_PORTAL'
export const SET_CONFIG = 'SET_CONFIG'

const state = {
  returnShopPortal: {},
  config: {},
}

const getters = {
  uuid (state, getters, rootState) {
    return rootState.route.params.returnShopPortalId
  },

  configActivated (state) {
    if (state.config) {
      return Object.keys(state.config)
    }
  },

  config (state) {
    return state.config
  },

  contacts (state) {
    return state.returnShopPortal.contacts
  },

  countryContactMappings(state) {
    return state.returnShopPortal.countryContactMappings
  },

  customer (state) {
    return state.returnShopPortal.customer
  },

  overviewUrl (state, getters) {
    return `#/returnshopportals/${getters.uuid}`
  },

  appearanceUrl (state, getters) {
    return `#/returnshopportals/${getters.uuid}/appearance`
  },

  settingsUrl (state, getters) {
    return `#/returnshopportals/${getters.uuid}/settings`
  },

  preadviseSettingsUrl (state, getters) {
    return `#/returnshopportals/${getters.uuid}/preadviseSettings`
  },

  textsUrl (state, getters) {
    return `#/returnshopportals/${getters.uuid}/texts/consumer`
  },

  mappingsUrl (state, getters) {
    return `#/returnshopportals/${getters.uuid}/mappings`
  },

  parcelNumberContainersUrl (state, getters) {
    return `#/returnshopportals/${getters.uuid}/parcelnumbercontainers`
  },

  instructionsDocumentUrl (state, getters) {
    return `#/returnshopportals/${getters.uuid}/instructionsdocument`
  },

  countryContactsMappingMap (state) {
    if(!state.returnShopPortal || !state.returnShopPortal.countryContactMappings) {
      return {}
    }
    const {countryContactMappings} = state.returnShopPortal

    return countryContactMappings.reduce( (acc, cur) => {
      if(acc[cur.destinationContactId]) {
        acc[cur.destinationContactId].push(cur.originCountry)
      } else {
        acc[cur.destinationContactId] = [cur.originCountry]
      }
      return acc
    }, {})
  },

  selectedReturnReasonsMapingMap (state) {
    if(!state.config || !state.config.selectedReturnReasons) {
      return {}
    }
    else return (state.config.selectedReturnReasons);
  }

}

const actions = {
  fetch ({commit, getters, rootState}) {
    const profile = Vue.prototype.profile
    const dataService = new DataService(profile, rootState.tokens)
    const uuid = getters.uuid

    return dataService.getReturnShopPortalByUUID(uuid)
      .then( result => result.data)
      .then(data => {
        commit(SET_RETURN_SHOP_PORTAL, data)
        commit(SET_CONFIG, data.config)
      })
      .catch(err => {
        commit(SET_RETURN_SHOP_PORTAL, {})
        // console.error('TODO: handle error', err)
        alert('unable to get returnshopportal: ' + err.message)
      })
  },

  fetchConfig() {
    console.error('deprecated: fetchConfig')
  },

  saveConfig ({state, commit, getters, rootState}, payload) {
    const profile = Vue.prototype.profile
    const dataService = new DataService(profile, rootState.tokens)

    payload.hero = state.config.hero
    payload.logo = state.config.logo

    const config = Object.assign(state.config, payload)

    config.texts = config.texts ? config.texts : {}
    config.mailTexts = config.mailTexts ? config.mailTexts : {}
    config.instructionsDocument = config.instructionsDocument ? config.instructionsDocument : ""
    config.selectedReturnReasons = config.selectedReturnReasons ? config.selectedReturnReasons : []
    config.heroTextColor = config.heroTextColor ? config.heroTextColor : ""
    config.fieldTextColor = config.fieldTextColor ? config.fieldTextColor : ""
    config.buttonColor = config.buttonColor ? config.buttonColor : ""
    config.buttonTextColor = config.buttonTextColor ? config.buttonTextColor : ""
    config.pageTextColor = config.pageTextColor ? config.pageTextColor : ""
    config.parcelShopInfoBackgroundColor = config.parcelShopInfoBackgroundColor ? config.parcelShopInfoBackgroundColor : ""

    return dataService.saveReturnShopPortalConfig(state.returnShopPortal.id, config)
      .then(result => result.data)
      .then(data => {
        commit(SET_CONFIG, data.config)
      })
  },

  saveCountryContactMappings({state, rootState}, countryContactMappings) {
    const profile = Vue.prototype.profile
    const dataService = new DataService(profile, rootState.tokens)

    return dataService.setReturnShopCountryContactMappings(state.returnShopPortal.id, countryContactMappings)
      .then(result => result.data)
  },

  setReturnShopPortalActive({state, commit, getters, rootState}, isActive) {
    const profile = Vue.prototype.profile
    const dataService = new DataService(profile, rootState.tokens)

    return dataService.setReturnShopPortalActive(state.returnShopPortal.id, isActive)
      .then(() => {
        commit(SET_RETURN_SHOP_PORTAL_ACTIVE, isActive)
      })
  },

  renameReturnShopPortal({state, commit, getters, rootState}, newName) {
    const profile = Vue.prototype.profile
    const dataService = new DataService(profile, rootState.tokens)

    return dataService.renameReturnShopPortal(state.returnShopPortal.id, newName)
      .then(() => {
        commit(RENAME_RETURN_SHOP_PORTAL, newName)
      })
  }
}

const mutations = {
  [SET_RETURN_SHOP_PORTAL] (state, value) {
    state.returnShopPortal = value
  },

  [SET_RETURN_SHOP_PORTAL_ACTIVE] (state, value) {
    if(state.returnShopPortal) {
      state.returnShopPortal.active = value
    }
  },

  [RENAME_RETURN_SHOP_PORTAL] (state, value) {
    if(state.returnShopPortal) {
      state.returnShopPortal.uuid = value
    }
  },

  [SET_CONFIG] (state, value) {
    state.config = value
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./client/store/modules/return-shop-portal.js